
export const orders = {
  videoRequests: {
    activeRequests: "Active Video Requests",
    pastRequests: "Past Video Requests",
    loading: "Loading...",
    deadline: "Deadline",
    price: "Price",
    status: {
      new: "New",
      accepted: "In Progress",
      completed: "Completed",
      rejected: "Rejected"
    },
    download: "Download",
    noActiveRequests: "No active video requests",
    noPastRequests: "No past video requests"
  },
  questions: {
    title: "My Questions",
    loading: "Loading your questions...",
    noQuestions: "You don't have any questions yet",
    noQuestionsDescription: "When you send a question to the creator, it will appear here",
    askQuestion: "Ask a Question",
    date: "Date",
    status: {
      answered: "Answered",
      pending: "Pending"
    },
    newQuestion: "New Question",
    questionPlaceholder: "Type your question here...",
    send: "Send Question",
    successToast: {
      title: "Question Sent",
      description: "Your question has been sent successfully. The response will cost 2000 Ft which you'll need to pay to view the answer."
    },
    errorToast: {
      title: "Error Occurred",
      description: "Failed to send your question, please try again later."
    },
    continueConversation: "Continue conversation (2000 Ft)",
    payForReply: "Pay for reply (2000 Ft)"
  }
};
